import React, { useState, Fragment, useEffect } from "react";
import Slider from "react-slick";
import ProductAddToCart from "./ProductAddToCart";
import { globalFileServer } from "../../../../axiosInstance";
import ProductInfo from "../../productInfo/ProductInfo";
import PricesCompareTable from "./PricesCompareTable";
import { use } from "react";

const ProductPage = ({ selectedProd, setImageModal }) => {
  const [currSlide, setCurrSlide] = useState(1);
  const [imgView, setImgView] = useState(
    selectedProd.media?.length ? selectedProd.media.at(-1).path : false
  );

  const settings = {
    rtl: window.innerWidth > 1000 ? true : false,
    dots: false,
    arrows: window.innerWidth > 1000 ? true : false,
    infinite: window.innerWidth > 1000 ? true : false,
    speed: 200,
    slidesToShow:
      window.innerWidth > 1000
        ? selectedProd.PathUrl && selectedProd.PathUrl.split(",").length < 3
          ? selectedProd.PathUrl.split(",").length
          : 3
        : 1,
    slidesToScroll:
      window.innerWidth > 1000
        ? selectedProd.PathUrl && selectedProd.PathUrl.split(",").length < 3
          ? selectedProd.PathUrl.split(",").length
          : 3
        : 1,
    afterChange: (index) => setCurrSlide(index + 1),
  };

  return (
    <div className="product-pop-up">
      <div className="product-img">
        <img
          loading="lazy"
          onClick={() => setImageModal(imgView)}
          src={
            imgView
              ? `${globalFileServer}products/${imgView}`
              : `${globalFileServer}/placeholder.jpg`
          }
        />
        <div
          onClick={() => setImageModal(imgView)}
          className="img"
          style={{
            backgroundImage: selectedProd.PathUrl
              ? `url(${globalFileServer}products/${imgView})`
              : `url(${globalFileServer}/placeholder.jpg)`,
          }}
        />
        <div className="price-btn">
          <ProductAddToCart element={selectedProd} haveInfo={true} />
        </div>
      </div>

      <div className="product-details">
        <div
          className="prod-info"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <div style={{ flex: 1 }}>
            <ProductInfo selectedProd={selectedProd} />
            <div className="prod-info-quantity">
              {selectedProd.weightJump > 1 ? (
                <span>
                  <br />
                  <span>{selectedProd.weightJump}</span>
                  <span> יחי' של </span>
                  <span className="weight-quantity">
                    {selectedProd.weightDetails.netContent}
                  </span>
                  <span>{selectedProd.weightDetails.unitOfMeasure}</span>
                </span>
              ) : null}
            </div>
          </div>
          <div className="kashrut">
            {selectedProd.kosherSupervision ? (
              <img
                loading="lazy"
                src={
                  globalFileServer +
                  "iconcss/" +
                  selectedProd.KashrutId +
                  ".svg"
                }
                alt={selectedProd.kosherSupervision[0].supervisionAgency}
              />
            ) : null}
          </div>
        </div>
        <div>
          {selectedProd.Expired && (
            <p>
              תוקף: {new Date(selectedProd.Expired).toLocaleDateString("en-GB")}
            </p>
          )}
          {selectedProd.gtin && (
            <p>{selectedProd.gtin && `ברקוד: ${selectedProd.gtin}`}</p>
          )}
        </div>
        <PricesCompareTable selectedProd={selectedProd} />
      </div>
    </div>
  );
};

export default ProductPage;
